<template>
  <div class="vuestic-widget preview-widget">
    <div class="vuestic-widget-header justify--center">
      {{isCreateModeActive ? $t(`traveller.newEntryTitle`) : $t(`traveller.editEntryTitle`) }}
      <router-link
        :to="{name: 'trip-details', params:{ tripId:tripId }}"
        class="plain-link ml-2"
        href="#"
      >{{ this.trip.title }}</router-link>
    </div>
    <div class="vuestic-widget-body main-body">
      <div v-if="isLoading">
        <spring-spinner slot="loading" :animation-duration="2500" :size="70" color="#4ae387" />
      </div>
      <form @submit.prevent @keydown.enter.prevent>
        <div class="va-row">
          <div class="flex md4">
            <search-select-list
              ref="searchBox"
              :label="$t(`traveller.newPerson`)"
              v-model="selectedPerson"
              option-key="comboboxLabel"
              :options="people"
              @searchchange="updateOptions"
              @selection="selectPerson"
              @unselectOption="startFresh"
            />
          </div>
          <div class="flex md4">
            <button
              tabindex="-1"
              @click="startFresh"
              class="btn btn-secondary btn-micro pull-right"
            >{{ $t('traveller.clean') }}</button>
          </div>
        </div>
        <div class="va-row">
          <div class="flex md4">
            <div class="form-group with-icon-right">
              <div class="input-group">
                <input
                  autocomplete="off"
                  v-model="personData.nameLatin"
                  id="nameLatin-input"
                  name="nameLatin-input"
                  required
                />
                <label
                  class="control-label placeholder-label"
                  for="nameLatin-input"
                  role="button"
                >{{$t("traveller.nameLatin")}}</label>
                <i class="bar"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="va-row">
          <div class="flex sm2">
            <div class="form-group with-icon-right">
              <div class="input-group">
                <input
                  autocomplete="off"
                  maxlength="10"
                  v-model="personData.identityNumber"
                  id="identityNumber"
                  name="identityNumber"
                  data-vv-name="identityNumber"
                  v-validate="'required|numeric:point|max:10'"
                  data-vv-validate-on="change|input"
                  required
                />
                <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                <i class="fa fa-check valid-icon icon-right input-icon"></i>
                <label
                  class="control-label placeholder-label"
                  for="identityNumber"
                  role="button"
                >{{$t("traveller.identityNumber")}}</label>
                <i class="bar"></i>
                <small
                  v-show="errors.has('identityNumber')"
                  class="help text-danger"
                >{{ errors.first('identityNumber') != null ? errors.first('identityNumber').replace('identityNumber',$t('traveller.identityNumber').toUpperCase()) : "" }}</small>
              </div>
            </div>
          </div>
          <!-- <div class="flex md4">
            <div class="flex" v-if="!isNaN(age)">{{$t("traveller.age")}}: {{age}}</div>
          </div>-->
        </div>
        <div class="va-row mb-3">
          <div class="col-sm-1">
            <div class="text-center">
              <div class="vuestic-icon">
                <span aria-hidden="true" class="fa fa-id-card-o" style="font-size: 25px;"></span>
              </div>
              <div class="icon-text">{{$t('traveller.idCard')}}</div>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group with-icon-right">
              <div class="input-group">
                <input
                  class="registration-input"
                  id="identityCardNumber"
                  name="identityCardNumber"
                  data-vv-name="identityCardNumber"
                  v-validate="'numeric:point|max:10'"
                  data-vv-validate-on="change|input"
                  v-model="personData.identityCardNumber"
                  required
                />
                <label class="control-label number-label placeholder-label" for="id-number">№:</label>
                <i class="bar"></i>
                <small
                  v-show="errors.has('identityCardNumber')"
                  class="help text-danger"
                >{{ errors.first('identityCardNumber') != null ? errors.first('identityCardNumber').replace('identityCardNumber',$t('traveller.idCardNumber')) : "" }}</small>
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group with-icon-right">
              <div class="input-group">
                <vuestic-date-picker
                  id="date-picker-id-issueDate"
                  v-model="personData.identityCardCreationDate"
                  :config="{
                    dateFormat: 'd-m-Y',
                }"
                  :required="true"
                />
                <label
                  class="control-label text-label"
                  for="date-picker-id-issueDate"
                >{{ $t(`traveller.issueDate`) }}</label>
                <i class="bar"></i>
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group with-icon-right">
              <div class="input-group">
                <vuestic-date-picker
                  id="date-picker-id-expiryDate"
                  v-model="personData.identityCardExpirationDate"
                  :config="{
                    dateFormat: 'd-m-Y',
                }"
                  :required="true"
                />
                <label
                  class="control-label text-label"
                  for="date-picker-id-expiryDate"
                >{{ $t(`traveller.cardExpiryDate`) }}</label>
                <i class="bar"></i>
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group with-icon-right">
              <div class="input-group">
                <input
                  autocomplete="off"
                  class="registration-input"
                  id="issuedBy"
                  name="issuedBy"
                  v-model="personData.identityCardIssuer"
                  required
                />
                <label class="control-label text-label" for="issuedBy">{{$t(`traveller.issuedBy`)}}</label>
                <i class="bar"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="va-row mb-3">
          <div class="col-sm-1">
            <div class="text-center">
              <div class="vuestic-icon">
                <span aria-hidden="true" class="entypo entypo-newspaper" style="font-size: 30px;"></span>
              </div>
              <div class="icon-text">{{$t('traveller.passport')}}</div>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group with-icon-right">
              <div class="input-group">
                <input
                  required
                  class="registration-input"
                  id="passport-number"
                  name="passportNumber"
                  data-vv-name="passportNumber"
                  v-model="personData.passportNumber"
                  v-validate="'numeric:point|max:10'"
                  data-vv-validate-on="change|input"
                />
                <label class="control-label number-label placeholder-label" for="passport-number">№:</label>
                <i class="bar"></i>
                <small
                  v-if="errors.has('passportNumber')"
                  class="help text-danger"
                >{{ errors.first('passportNumber').replace("passportNumber",$t('traveller.passport')) }}</small>
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group with-icon-right">
              <div class="input-group">
                <vuestic-date-picker
                  id="passport-date-picker-from"
                  v-model="personData.passportCreationDate"
                  name="passportCreationDate"
                  data-vv-name="passportCreationDate"
                  :config="{
                    dateFormat: 'd-m-Y',
                }"
                />
                <label
                  class="control-label text-label"
                  for="passport-date-picker-from"
                >{{ $t(`traveller.issueDate`) }}</label>
                <i class="bar"></i>
                <small
                  v-if="errors.has('passportCreationDate')"
                  class="help text-danger"
                >{{ errors.first('passportCreationDate').replace("passportCreationDate",$t('traveller.issueDate')) }}</small>
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group with-icon-right">
              <div class="input-group">
                <vuestic-date-picker
                  :required="true"
                  id="passport-date-picker-to"
                  name="passportExpirationDate"
                  data-vv-name="passportExpirationDate"
                  v-model="personData.passportExpirationDate"
                  :config="{
                    dateFormat: 'd-m-Y',
                }"
                />
                <label
                  class="control-label text-label"
                  for="passport-date-picker-to"
                >{{ $t(`traveller.validTo`) }}</label>
                <i class="bar"></i>
                <small
                  v-if="errors.has('passportExpirationDate')"
                  class="help text-danger"
                >{{ errors.first('passportExpirationDate').replace("passportExpirationDate",$t('traveller.validTo')) }}</small>
              </div>
            </div>
          </div>
          <span class="col-md-2 text-danger help">{{hasExpireWarning}}</span>
        </div>
        <div class="va-row">
          <div class="col-sm-2">
            <vuestic-simple-select
              v-if="trip.requireVisa"
              :label="$t('traveller.visa')"
              :clearable="false"
              v-model="hasVisa"
              name="hasVisa"
              ref="hasVisa"
              option-key="label"
              v-bind:options="visaOptions"
            ></vuestic-simple-select>
            <small
              v-if="errors.has('hasVisa')"
              class="help text-danger"
            >{{ errors.first('hasVisa') }}</small>
          </div>
        </div>
        <div class="va-row">
          <div class="flex md4 form-group with-icon-right mb-3">
            <div class="input-group">
              <input
                autocomplete="off"
                id="email"
                name="email"
                v-model="personData.email"
                required
                data-vv-name="email"
                v-validate="'emailValidation|max:30'"
                data-vv-validate-on="blur"
              />
              <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
              <i class="fa fa-check valid-icon icon-right input-icon"></i>
              <label class="control-label placeholder-label" for="email">{{$t("traveller.email")}}</label>
              <i class="bar"></i>
              <small
                v-show="errors.has('email')"
                class="help text-danger"
              >{{ errors.first('email') }}</small>
            </div>
          </div>
          <div class="flex md2 form-group with-icon-right mb-3">
            <div class="input-group">
              <input
                id="phone"
                name="phone"
                v-model="personData.phone"
                data-vv-name="phone"
                v-validate="'max:20'"
                data-vv-validate-on="change|input"
                required
              />
              <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
              <i class="fa fa-check valid-icon icon-right input-icon"></i>
              <label class="control-label placeholder-label" for="phone">{{$t("traveller.phone")}}</label>
              <i class="bar"></i>
              <small
                v-if="errors.has('phone')"
                class="help text-danger"
              >{{ errors.first('phone').replace("phone",$t('traveller.phone')) }}</small>
            </div>
          </div>
        </div>
        <div class="va-row">
          <div class="flex md3 text-center offset--md3" v-show="isCreateModeActive">
            <button
              type="button"
              class="btn btn-sm btn-warning"
              @click="createTraveller()"
            >{{$t("traveller.save")}}</button>
          </div>
        </div>
        <div class="trip-info" v-show="!isCreateModeActive">
          <div class="va-row">
            <div class="flex md1">
              <div class="form-group with-icon-right" id="price-wrapper">
                <div class="input-group">
                  <input
                    v-model="travelData.singlePrice"
                    id="price-input"
                    name="price-input"
                    required
                  />
                  <label
                    class="control-label placeholder-label"
                    for="price-input"
                    role="button"
                  >{{$t("general.price")}}</label>
                  <i class="bar"></i>
                </div>
              </div>
            </div>
            <div class="flex" v-if="participantId != ''">
              <div class="flex currency">{{$t("general.currency.long")}}</div>
            </div>
            <div class="flex md2" v-if="participantId != ''">
              <button
                type="button"
                class="btn btn-micro btn-primary"
                @click="openPayments()"
              >{{$t("traveller.payments")}}</button>
              <vuestic-modal
                :noButtons="true"
                v-bind:force="true"
                ref="paymentsModal"
                :cancelClass="'none'"
              >
                <div
                  slot="title"
                >{{ $t('payment.header',{ name:selectedPerson.name,idNumber:personData.identityNumber, price:travelData.singlePrice})}}</div>
                <payment
                  v-bind:tripId="trip.id"
                  v-bind:tripPrice="+travelData.singlePrice"
                  v-bind:participantId="participantId"
                ></payment>
              </vuestic-modal>
            </div>
            <div class="va-row flex form-group md4">
                  <div class="input-group">
                    <textarea
                      id="notes-textarea" class="notes-wrapper"
                      style="margin-top:10px"
                      v-model="travelData.priceNotes"
                      type="text"></textarea>
                    <label class="control-label placeholder-label">{{$t(`traveller.priceNotes`)}}</label>
                  </div>
                </div>
          </div>

          <div class="va-row" style="margin-top:20px">
            <div class="flex md3">
              <vuestic-simple-select
                :label="$t('traveller.influence')"
                :clearable="false"
                ref="influenceSource"
                v-model="influenceSource"
                name="influenceSource"
                option-key="label"
                v-bind:options="influenceSourceOptions"
              ></vuestic-simple-select>
              </div>
          </div>
          <div class="va-row">
            <div class="flex md2">
              <vuestic-simple-select
                :label="$t('traveller.enrolment')"
                :clearable="false"
                ref="enrolmentType"
                v-model="enrolmentType"
                name="enrolmentType"
                option-key="label"
                v-bind:options="enrolmentTypeOptions"
              ></vuestic-simple-select>
              </div>
          </div>
          <div class="va-row">
            <div class="flex md4">
              <vuestic-simple-select
                :label="$t('traveller.type')"
                :clearable="false"
                ref="travellerType"
                v-model="travellerType"
                name="travellerType"
                option-key="label"
                v-bind:options="[{ label: $t(`traveller.types.guide`), value: 'guide' }, 
                        { label: $t(`traveller.types.driver`), value: 'driver' },
                        { label: $t(`traveller.types.cleric`), value: 'cleric' },
                        { label: $t(`traveller.types.traveller`), value: 'traveller' }]"
              ></vuestic-simple-select>
              </div>
              <div class="flex md2">
                    <role-color-picker
                      class="va-row"
                      v-show="travelData.role == 'traveller'"
                      v-model="travelData.association"
                    ></role-color-picker>
              </div>
            
          </div>
          <div class="step-2 mt-2">
            <div class="va-row flex">
              <div class="flex md4 ">
                <div class="va-row flex">
                  <vuestic-simple-select
                    :label="$t('traveller.room')"
                    :clearable="false"
                    v-model="travelData.roomType"
                    name="tripDestination"
                    v-bind:options="[$t(`traveller.single`), $t(`traveller.double`), $t(`traveller.doubleBed`), $t(`traveller.triple`), $t(`traveller.other`)]"
                  ></vuestic-simple-select>
                </div>
              </div>
            </div>
            <div class="va-row flex">
              <div class="flex md6">
                <div class="va-row flex form-group">
                  <div class="input-group">
                    <textarea class="notes-wrapper"
                    style="margin-top:10px" v-model="travelData.notes" type="text" id="notes-textarea"></textarea>
                    <label
                      class="control-label placeholder-label"
                      
                    >{{$t(`traveller.notes`)}}</label>
                    <!-- <i class="bar"></i> -->
                  </div>
                </div>
              </div>
              </div>
              <div class="va-row flex">
              <div class="flex md4">
                    <div class="control-label">{{$t("traveller.busPlace")}} : {{this.busPlaceLabel}}</div>
                  </div>
                  
                <div class="va-row md6">
                  
                  <div class="flex md6" v-if="participantId != '' && (travellerType == null || (travellerType != null && travellerType.value != 'driver'))">
                          <button
                            type="button"
                            class="btn btn-micro btn-primary"
                            @click="openBus()"
                          >
                          <i class="fa fa-bus" />
                          </button>
                        </div>
                </div>
            </div>
            <div class="va-row" v-if="travellerType != null && travellerType.value != 'driver' && travelData.busPlace != 0">
            <div class="flex md4">
                          <div
                    class="control-label"
                  >{{$t("traveller.lockPlace")}}</div>
                  </div>
                  <div class="flex md4">
                        <toggle-button :sync="true" v-model="placeLocked" :color="{checked: '#4ae387', unchecked: '#EA3C53'}" :width="80" :height="35" :font-size="16" :labels="true">
                          <span slot="checked" ><i class="fa fa-unlock" /></span>
                          <span slot="unchecked" ><i class="fa fa-lock" /></span>
                        </toggle-button>
                    </div>
                    </div>

            <div class="va-row">
              <div class="flex md4">
                <div class="form-group with-icon-right">
                  <div class="input-group">
                    <input v-model="travelData.children" id="children" name="children" required />
                    <label
                      class="control-label placeholder-label"
                      for="children"
                      role="button"
                    >{{$t("traveller.children")}}</label>
                    <i class="bar"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="va-row">
              <div class="flex md4">
                <div class="va-row flex">
                  <label class="control-label" for="download-contract">{{$t("traveller.contract")}}:</label>
                </div>
                <div class="va-row flex">
                  <div
                    class="control-label"
                    for="upload-contract"
                  >{{$t("traveller.contractSignature")}}:</div>
                </div>
              </div>
              <div class="flex md6">
                <button
                  type="button"
                  class="btn btn-micro btn-primary"
                  @click="downloadGeneratedDocument('document')"
                >{{$t("traveller.download")}}</button>
                <div class="va-row flex" id="file-upload-btn-wrapper">
                  <div v-show="this.hasSignedContract">
                    <button
                      @click="downloadDocument(signedContract)"
                      class="btn btn-secondary btn-micro mr-2"
                    >{{ $t('traveller.download') }}</button>
                    <button
                      @click="deleteContract"
                      class="btn btn-secondary btn-micro"
                    >{{ $t('traveller.delete') }}</button>
                  </div>
                  <vuestic-file-upload
                    v-show="!this.hasSignedContract"
                    type="single"
                    :file-types="'.pdf'"
                    v-model="conctactSignned"
                  />
                </div>
              </div>
              <div class="flex md4">
                <button
                  type="button"
                  class="btn btn-micro btn-primary"
                  @click="downloadGeneratedDocument('annex')"
                >{{$t("traveller.downloadAnnex")}}</button>
              </div>
              <div class="flex md4">
                <button
                  type="button"
                  class="btn btn-micro btn-primary"
                  @click="downloadGeneratedDocument('voucher')"
                >{{$t("traveller.downloadVoucher")}}</button>
              </div>
            </div>

          </div>

          <div class="va-row" style="padding-top:15px">
          
            <div class="flex md4">
              <span class="mr-3">{{$t('traveller.status')}}:</span>
            </div>
              <toggle-button :sync="true" v-model="declined" :color="{checked: '#4ae387', unchecked: '#EA3C53'}" :width="110" :height="35" :font-size="16" :labels="{checked: `${$t('traveller.enrolled')}`, unchecked: `${$t('traveller.declined')}`}" />
          
          </div>
        </div>
        

      </form>
    </div>
    <vuestic-modal
                            :noButtons="true"
                            :large="true"
                            v-bind:force="true"
                            ref="busModal"
                            :cancelClass="'none'"
                            @cancel="getPersonTravelDetails()"
                            @open="$refs.placePicker.getTravelers()"
                          >
                          <div slot="title">{{'traveller.bus' | translate}}</div>
                            <place-picker 
                            ref="placePicker"
                            :tripId="parseInt(trip.id)"
                            :participantId="this.participantId"></place-picker>
                          </vuestic-modal>
  </div>
</template>

<script>
import _ from "lodash";
import CustomSearchList from "vuestic-components/vuestic-simple-select/CustomSearchList";

import moment, { months } from "moment";
import axios from "axios";
import { baseUrl, host } from "../../../services/http"; // TODO: Move to api
import { isExpiringSoon, isEmptyString } from "../../../utils";
import { personApi } from "../../../services/api/personApi";
import { tripApi } from "../../../services/api/tripApi";

import RoleColorPicker from "../../role-color-picker/RoleColorPicker";

import Payment from "../../payment/Payment.vue";
import PlacePicker from "../../bus/PlacePicker.vue";
import Vue from "vue";

const waitBeforeSave = 3000;
const nameListLength = 5;

export default {
  name: "AddTraveller",
  props: {
    tripId: String,
    personId: {
      type: String,
      default: null
    }
  },
  components: {
    CustomSearchList,
    Payment,
    RoleColorPicker,
    PlacePicker
  },
  created() {
    return this.getTripInfo().then(() => {
      if (this.personId) {
        return personApi.getPersonById(this.personId).then(personData => {
          this.createComboboxLabel([personData]);
          this.$refs.searchBox.selectOption(personData);
        });
      }
      return Promise.resolve();
    });
  },
  mounted() {
    this.$validator.extend("emailValidation", {
      getMessage: field => this.$t("warnings.invalidEmail"),
      validate: email => {
        let re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return re.test(String(email).toLowerCase());
      }
    });
  },
  computed: {
    getSuggestedPeopleDebounced() {
      return _.debounce(this.getSuggestedPeople.bind(this), 650);
    },
    debouncedUpdateTravelDetails() {
      return this.isCreateModeActive == false
        ? _.debounce(this.updateTravelDetails.bind(this), waitBeforeSave)
        : () => {}; // no auto save in create mode
    },
    debouncedUpdatePersonDetails() {
      return this.isCreateModeActive == false
        ? _.debounce(this.updatePersonDetails.bind(this), waitBeforeSave)
        : () => {}; // no auto save in create mode
    },
    age() {
      if (this.personData.identityNumber.length < 6) return "";
      return moment().diff(
        moment(this.personData.identityNumber.slice(0, 6), "YYMMDD"),
        "years"
      );
    },
    hasExpireWarning() {
      return isExpiringSoon(
        this.trip.startDate,
        moment(this.personData.passportExpirationDate, "DD-MM-YYYY")
      )
        ? this.$t("warnings.passportExpiring")
        : "";
    },
    hasSignedContract() {
      return !!this.signedContract;
    },
    declined:{
      get:function(){
        return !this.travelData.decline;
      },
      set:function(newValue){
        this.travelData.decline = !newValue*1;
      }
    },
    placeLocked: {
      get:function(){
        return !this.travelData.placeIsLocked;
      },
      set:function(newValue){
        this.travelData.placeIsLocked = newValue? 0 : 1;
      }
    },
    busPlaceLabel() {
      if (this.travellerType != null && this.travellerType.value == 'driver') {
        return this.$t("traveller.service")
      }
      if (this.travelData.busPlace == 0) {
        return this.$t("traveller.none")
      }
      return this.travelData.busPlace
    }
  },
  // beforeRouteUpdate(to, from, next) {
  //   //the component should refresh itself when you try to navigate back
  //   console.log("beforeRouteUpdate: ")
  //   var tripId = to.query.tripId
  //   var personId = to.query.personId
  //   // console.log("Params: ", JSON.stringify(tripId))
  //   // console.log("Params: ", JSON.stringify(personId))
  //   this.tripId = tripId
  //   this.personId = tripId

  //   this.getTripInfo().then(() => {
  //     if (this.personId) {
  //       return personApi.getPersonById(this.personId).then(personData => {
  //         this.createComboboxLabel([personData]);
  //         this.$refs.searchBox.selectOption(personData);
  //       });
  //     }
  //     return Promise.resolve();
  //   })
  //   next()
  // },
  data () {
    return {
      personData: {
        nameLatin: "",
        identityNumber: "",
        identityCardNumber: "",
        identityCardCreationDate: "",
        identityCardExpirationDate: "",
        identityCardIssuer: "",
        passportNumber: "",
        passportCreationDate: "",
        passportExpirationDate: "",
        phone: "",
        email: "",
        id: null,
        name: ""
      },
      visaOptions: [
        { label: this.$t("general.no"), value: 0 },
        { label: this.$t("general.yes"), value: 1 }
      ],
      hasVisa: null,
      selectedPerson: {
        id: -1,
        comboboxLabel: "",
        name: ""
      },
      isCreateModeActive: true,
      isLoading: false,
      travelData: {
        hasVisa: false,
        busPlace: "",
        roomType: "",
        children: "",
        singlePrice: "",
        notes: "",
        priceNotes: "",
        enrolmentType: 0,
        influenceSource: 0,
        role: "traveller",
        association: "",
        decline: 1,
        placeIsLocked: 0
      },
      travellerType: {
        label: this.$t(`traveller.types.traveller`),
        value: "traveller"
      },
      enrolmentType: {
        label: '',
        value: 0
      },
      enrolmentTypeOptions: [
        { label: '', value: 0 },
        { label: this.$t(`traveller.enrolmentType.office`), value: 1 },
        { label: this.$t(`traveller.enrolmentType.site`), value: 2 },
        { label: this.$t(`traveller.enrolmentType.parish`), value: 3 }
      ],
      influenceSource: {
        label: '',
        value: 0
      },
      influenceSourceOptions: [
        { label: '', value: 0 },
        { label: this.$t(`traveller.influenceSource.facebook`), value: 1 },
        { label: this.$t(`traveller.influenceSource.church`), value: 2 },
        { label: this.$t(`traveller.influenceSource.site`), value: 3 },
        { label: this.$t(`traveller.influenceSource.recommendation`), value: 4 }
      ],
      signedContract: null,
      participantId: "",
      conctactSignned: [],
      trip: {
        id: "",
        requireVisa: false,
        requirePassport: false,
        startDate: moment(0)
      },
      people: [] //default one that will always be last in order to create a new person
    };
  },
  watch: {
    conctactSignned(contract) {
      if (contract.length > 0) {
        //contract added
        this.uploadContract(contract[0]);
      }
    },
    selectedPerson(newlySelected) {
      if (newlySelected.id != -1) {
        let newPerson = { ...newlySelected };
        delete newPerson.comboboxLabel;

        let passportCreationDate =
          newlySelected.passportCreationDate == 0
            ? ""
            : moment(newlySelected.passportCreationDate, "X").format(
                "DD-MM-YYYY"
              );

        let passportExpirationDate =
          newlySelected.passportExpirationDate == 0
            ? ""
            : moment(newlySelected.passportExpirationDate, "X").format(
                "DD-MM-YYYY"
              );

        let identityCardExpirationDate =
          newlySelected.identityCardExpirationDate == 0
            ? ""
            : moment(newlySelected.identityCardExpirationDate, "X").format(
                "DD-MM-YYYY"
              );

        let identityCardCreationDate =
          newlySelected.identityCardCreationDate == 0
            ? ""
            : moment(newlySelected.identityCardCreationDate, "X").format(
                "DD-MM-YYYY"
              );

        this.personData = {
          ...this.personData,
          ...newPerson,
          identityCardCreationDate,
          identityCardExpirationDate,
          passportCreationDate,
          passportExpirationDate
        };

        oldPersonModel = {
          ...this.personData
        };

        this.getPersonTravelDetails().then(() => {
          this.isCreateModeActive = false;
        });
      } else {
        this.isCreateModeActive = true;
      }
    },
    hasVisa(selected) {
      this.travelData.hasVisa = selected.value;
    },
    personData: {
      handler(newPersonModel) {
        if (this.isCreateModeActive == false) {
          this.debouncedUpdatePersonDetails(newPersonModel);
        }
      },
      deep: true
    },
    travelData: {
      handler: function(newTravelModel) {
        if (this.isCreateModeActive == false) {
          this.debouncedUpdateTravelDetails(newTravelModel);
        }
      },
      deep: true
    },
    "selectedPerson.comboboxLabel": function(label) {
      let idNumStart = label.indexOf("(");
      let name = "";
      if (idNumStart > 0) {
        name = label.slice(0, idNumStart - 1);
      } else {
        name = label;
      }
      this.selectedPerson.name = name;
      this.personData.name = name;
    },
    travellerType (newlySelected) {
      if (newlySelected) {
        this.travelData.role = newlySelected.value
      } else {
        this.travellerType = null
      }
    },
    enrolmentType (newlySelected) {
      if (newlySelected) {
        this.travelData.enrolmentType = newlySelected.value
      } else {
        this.enrolmentType = null
      }
    },
    influenceSource (newlySelected) {
      if (newlySelected) {
        this.travelData.influenceSource = newlySelected.value
      } else {
        this.influenceSource = null
      }
    }
  },
  methods: {
    selectPerson (personData) {
      this.startFresh()
      personData.comboboxLabel = personData.name
      this.selectedPerson = personData
    },
    updateCurrentPerson (event) {
      this.$nextTick(() => {
        this.personData.name = event.target._value
      })
    },
    downloadDocument (url) {
      const link = document.createElement("a");
      link.href = `${host}${url}`;
      link.setAttribute("download", "file.docx");
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
    },
    downloadGeneratedDocument(type) {
      if (!this.participantId) return Promise.reject("No participant id");
      return axios
        .get(
          `${baseUrl}/trip/${this.trip.id}/participant/${this.participantId}/${type}`
        )
        .then(res => {
          if (!res.data.success)
            return Promise.reject("error getting document link");
          this.downloadDocument(res.data.document.file);
        })
        .catch(e => {
          console.log("Error downloading contract");
        });
    },
    getPersonTravelDetails () {
      let request = null
      if (this.participantId) {
        request = axios.get(
          `${baseUrl}/trip/${this.trip.id}/participant/${this.participantId}`
        );
      } else {
        request = axios
          .get(`${baseUrl}/trip/${this.trip.id}/participant/all?items=200`)
          .then(res => {
            if (!res.data.success) { return }
            let participantData = res.data.participants.find(
              tp => tp.person.id === this.personData.id
            )
            if (participantData) {
              // the the person is already enlisted in this trip
              this.participantId = participantData.id
              res.data.participant = participantData
              return res
            } else {
              return this.createTravelData()
            }
          })
      }
      return request
        .then(resp => {
          if (resp.data.success) {
            const participant = resp.data.participant
            this.travelData = { ...participant }
            this.signedContract = participant.signedContract
            this.travellerType = this.$refs.travellerType.options.find(
              t => t.value === participant.role
            )
            this.enrolmentType = this.$refs.enrolmentType.options.find(
              t => t.value === participant.enrolmentType
            )
            this.influenceSource = this.$refs.influenceSource.options.find(
              t => t.value === participant.influenceSource
            )
            oldTravelModel = { ...this.travelData }
            if (this.$refs.hasVisa) {
              this.$refs.hasVisa.selectOption(
                this.visaOptions.find(
                  option => option.value === this.travelData.hasVisa
                )
              )
            }
          }
        })
        .catch(e => {
          console.log("Can't get person's trip details.", e)
        })
    },
    clear (field, prop) {
      !!prop ? (this[prop][field] = "") : (this[field] = "")
    },
    createComboboxLabel(people) {
      people.forEach(p => {
        p.comboboxLabel = `${p.name} (${p.identityNumber})`;
      });
    },
    getSuggestedPeople(containing) {
      personApi.fuzzy(containing).then(people => {
        this.createComboboxLabel(people);
        this.people = people;
      });
    },
    updateOptions(name) {
      if (name && name.length >= 3) {
        this.getSuggestedPeopleDebounced(name);
      }
    },
    updatePersonDetails(newPersonModel) {
      this.$validator.validateAll().then(() => {
        Object.keys(oldPersonModel).forEach(key => {
          if (
            oldPersonModel[key] != newPersonModel[key] &&
            newPersonModel[key] != ""
          ) {
            if (this.formFields[key] && this.errors.has(key)) return;

            personApi
              .update(this.personData.id, key, newPersonModel[key])
              .then(() => {
                oldPersonModel[key] = newPersonModel[key];
                this.showToast(`${this.$t("general.changesMade")}`);
              })
              .catch(e => {
                throw "Update failed";
              });
          }
        });
      });
    },
    updateTravelDetails(newTravelModel) {
      Object.keys(oldTravelModel).forEach(key => {
        if (oldTravelModel[key] != newTravelModel[key]) {
          tripApi
              .updateTravelDetails(this.trip.id, this.participantId, key, newTravelModel[key])
              .then(() => {
                oldTravelModel[key] = newTravelModel[key];
                this.showToast(`${this.$t("general.changesMade")}`);
              })
              .catch(e => {
                throw "Update failed";
              });
        }
      });
    },
    createTraveller() {
      this.$validator.validateAll().then(() => {
        if (this.errors.items.length != 0) return;
        let createModel = {
          ...this.personData
        };
        delete createModel.id;
        personApi
          .create(createModel)
          .then(person => {
            this.personData.id = person.id;
            this.isCreateModeActive = false;

            oldPersonModel = { ...this.personData };
            return person;
          })
          .then(() => {
            return this.createTravelData();
          })
          .then(resp => {
            return this.getPersonTravelDetails();
          })
          .catch(e => {
            throw "something went wrong";
          });
      });
    },
    createTravelData() {
      return axios
        .put(`${baseUrl}/trip/${this.trip.id}/participant/create`, {
          personId: this.personData.id,
          notes: "",
          singlePrice: this.travelData.singlePrice
        })
        .then(res => {
          if (!res.data.success)
            return Promise.reject(
              "Something went wrong while creating Travel Data"
            );
          this.participantId = res.data.participant.id;
          return res;
        });
    },
    getTripInfo() {
      return axios
        .get(`${baseUrl}/trip/${this.$props.tripId}`)
        .then(resp => {
          this.trip = {
            ...resp.data.trip,
            requireVisa: !!resp.data.trip.requireVisa,
            requirePassport: !!resp.data.trip.requirePassport,
            startDate: moment(resp.data.trip.startDate)
          };
          this.travelData.singlePrice = resp.data.trip.price;
        })
        .catch(e => {
          throw "something went wrong";
        });
    },
    uploadContract(contractFile) {
      let formData = new FormData();
      formData.append("documentType", 0);
      formData.append("document", contractFile);

      axios
        .post(`${baseUrl}/trip/document`, formData, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        })
        .then(res => {
          return axios.post(
            `${baseUrl}/trip/${this.trip.id}/participant/${this.participantId}`,
            {
              attribute: "signedContract",
              value: res.data.document.id
            }
          );
        })
        .then(res => {
          this.signedContract = res.data.participant.signedContract;
        })
        .catch(e => {
          console.log(e);
        });
    },
    deleteContract() {
      return axios
        .post(
          `${baseUrl}/trip/${this.trip.id}/participant/${this.participantId}`,
          {
            attribute: "signedContract",
            value: 0
          }
        )
        .then(res => {
          this.signedContract = null;
          this.conctactSignned = [];
        });
    },
    startFresh() {
      let tripInfo = this.trip;
      Object.assign(this.$data, this.$options.data.apply(this));
      this.trip = { ...tripInfo };
      this.travelData.singlePrice = this.trip.price;
      oldPersonModel = {};
      oldTravelModel = {};
      this.$nextTick(() => {
        this.$validator.reset();
      });
    },
    openPayments() {
      this.$refs.paymentsModal.open();
    },
    openBus() {
      this.$refs.busModal.open();
    }
  }
};

let oldPersonModel = {};

let oldTravelModel = {};

const bgToLatinDictionary = {
  а: "a",
  б: "b",
  в: "v",
  г: "g",
  д: "d",
  е: "e",
  ж: "zh",
  з: "z",
  и: "i",
  й: "y",
  к: "k",
  л: "l",
  м: "m",
  н: "n",
  о: "o",
  п: "p",
  р: "r",
  с: "s",
  т: "t",
  у: "u",
  ф: "f",
  х: "h",
  ц: "ts",
  ч: "ch",
  ш: "sh",
  щ: "sht",
  ъ: "a",
  ь: "y",
  ю: "yu",
  я: "ya"
};
</script>

<style lang="scss">
#label {
    color: red;
  }
.flex-top {
  display: flex; align-items: flex-start;
}
form {
  .radio-wrapper {
    border: 1px solid $vue-green;
    border-radius: 8px;
    padding: 10px;
    margin-left: 2rem !important;
  }
  #upload-contract-wrapper {
    position: relative;
    overflow: hidden;
    display: inline-block;
  }
  #upload-contract-wrapper input[type="file"] {
    font-size: 100px;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
  }

  

  .registration-input,
  .text-label,
  .number-label {
    margin: 0 0.4rem;
  }
  .number-label {
    font-size: 1.1rem;
  }
  #price-wrapper {
    margin: 0.2rem;
  }

  .notes-wrapper {
    border: 1px solid #b4c1b8;
    border-radius: 10px;
    padding: 14px;
  }
  .currency {
    display: flex;
    align-self: flex-end;
  }

  .action-hover:hover {
    cursor: pointer;
    text-decoration: underline;
  }
  .trip-info {
    margin-top: 70px;
  }
}

@media print {
  .main-body {
   display: none;
  }
  .vuestic-sidebar {
    display: none;
  }
  .no-print {
    display: none;
  }
  .modal-header {
    display: none;
  }
}
</style>
